import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Usuario } from '../Models/usuario.model';
import { UserToken } from '../Models/token.model';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { UrlApi } from '../Models/url-api.model';
import { ETipoLogin } from '../Models/Enumeradores/tipo-login.model';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class LoginService {

    token: UserToken;
    private usuario = new Usuario();


    private domParser: DOMParser;
    tipoLogin: string;
    strUrlKeycloak: string;
    strBodyGerarToken: string;

    constructor(private router: Router, private http: HttpClient) {
        this.domParser = new DOMParser();
    }

    estaLogado(): boolean {
        return !isNullOrUndefined(this.getTokenFromSessionStorage());
    }

    obterTipoUsuario(): string {
        return (JSON.parse(sessionStorage.getItem('usuariologado')) as UserToken).tipoLogin;
    }

    autenticarParticipante(usuario?: Usuario): Observable<any> {
        const cpf = usuario.cpf;
        const senha = usuario.senha;
        const participante = true;

        const grantType = 'grant_type=password';
        const data = `${grantType}&senha=${senha}&cpf=${cpf}&participante=${participante}`
        return this.http.post<UserToken>(`${UrlApi.URL_API}token`, data)
            .pipe(
                map((response: UserToken) => {
                    const token = response && response.access_token;

                    if (token) {
                        this.token = response;
                        this.token.tipoLogin = ETipoLogin.Participante;
                        this.setTokenOnSessionStorage(this.token);
                    }

                    return response;
                })
            );
    }

    esqueciMinhaSenha(cpf: string, email: string): Observable<boolean> {
        const data = `cpf=${cpf}&email=${email}`
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.get<boolean>(`${UrlApi.URL_API}login/esqueciminhasenha?cpf=${cpf}&email=${email}`, { headers: headers })
            .pipe(
                map((response: boolean) => {
                    return response;
                })
            );
    }

    setTokenOnSessionStorage(token: UserToken) {
        sessionStorage.setItem('usuariologado', JSON.stringify(token));
    }

    carregarMenu(): NodeList {
        const usuarioLogado: UserToken = JSON.parse(sessionStorage.getItem('usuariologado'));
        const documentMenuGSI = this.domParser.parseFromString(usuarioLogado.usuario_menu, 'application/xml');

        return documentMenuGSI.childNodes.item(0).childNodes;
    }

    logout() {
        this.token = undefined;
        sessionStorage.removeItem('usuariologado');
        this.usuario = undefined;
        this.handleLogin();
    }

    handleLogin() {
        if (environment.production) {
            if (this.usuario.tipoUsuario === ETipoLogin.GSI.toString()) {
                window.location.href = 'http://www.gsi.ms.gov.br';
            } else {
                this.router.navigate(['publico']);
            }
        } else {

        }
    }

    VerificarPermissoesUsuario(): boolean {
        if (this.estaLogado()) {
            return true;
        }

        return false;
    }

    getTokenFromSessionStorage(): string {
        const user = JSON.parse(sessionStorage.getItem('usuariologado'));
        if (user) {
            return (JSON.parse(sessionStorage.getItem('usuariologado')) as UserToken).access_token;
        }
        return undefined;
    }

    download() {
        let headers = new HttpHeaders({
            'Content-Type': 'application/octet-stream',
            'Content-Disposition': 'attachment',
            'filename':'test.pdf',
            'Access-Control-Allow-Origin': '*'  }); 
            console.log(`${environment.apiUrl}`);
    
            return this.http.get(`${environment.apiUrl}login/download`, { responseType: 'blob' });
            // .map(response => response);
      }
}